/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["no-results-message{width:100%;max-height:100%;display:flex;justify-content:center;align-items:center;flex-flow:column wrap;font-weight:300}no-results-message>.icon>img,no-results-message>.icon>svg{width:150px;height:150px;fill:currentColor}no-results-message>.text{text-align:center;margin-bottom:25px;width:100%;color:#43484d}no-results-message>.text>.main{font-size:2.6rem;font-weight:500}no-results-message>.text>.secondary{font-size:1.7rem;font-weight:400}no-results-message>.text a:hover{text-decoration:underline}"];
export { styles as styles };
